import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { http, getAuthorizationHeader } from '../config/http';

export const NotificationContext = createContext({
  pendingCounts: {
    total: 0,
    permohonan_brankas: 0,
    hapus_etalase: 0,
    transfer_toko: 0,
    hapus_pembelian: 0,
  },
  loading: false,
  fetchPendingCounts: () => {},
});

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const [pendingCounts, setPendingCounts] = useState({
    total: 0,
    permohonan_brankas: 0,
    hapus_etalase: 0,
    transfer_toko: 0,
    hapus_pembelian: 0,
  });
  const [loading, setLoading] = useState(false);

  const fetchPendingCounts = useCallback(async () => {
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');
    if (!token || role === 'kasir' || role === 'kasir_pembelian') {
      setPendingCounts({
        total: 0,
        permohonan_brankas: 0,
        hapus_etalase: 0,
        transfer_toko: 0,
        hapus_pembelian: 0,
      });
      return;
    }

    try {
      setLoading(true);
      const res = await http.get('notifications/pending-verifikasi', {
        headers: { Authorization: getAuthorizationHeader() },
      });
      if (res.data?.status && res.data?.data) {
        setPendingCounts(res.data.data);
      }
    } catch (err) {
      // Fail gracefully without disrupting UI
      console.debug('Failed to fetch pending verification counts:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPendingCounts();

    // Poll every 30 seconds
    const interval = setInterval(() => {
      fetchPendingCounts();
    }, 30000);

    const handleFocus = () => {
      fetchPendingCounts();
    };

    const handleRefreshEvent = () => {
      fetchPendingCounts();
    };

    const handleLogout = () => {
      setPendingCounts({
        total: 0,
        permohonan_brankas: 0,
        hapus_etalase: 0,
        transfer_toko: 0,
        hapus_pembelian: 0,
      });
    };

    window.addEventListener('focus', handleFocus);
    window.addEventListener('refresh-pending-verification', handleRefreshEvent);
    window.addEventListener('logout-success', handleLogout);

    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('refresh-pending-verification', handleRefreshEvent);
      window.removeEventListener('logout-success', handleLogout);
    };
  }, [fetchPendingCounts]);

  return (
    <NotificationContext.Provider value={{ pendingCounts, loading, fetchPendingCounts }}>
      {children}
    </NotificationContext.Provider>
  );
};
